// Shared navigation config — the single source of truth for the portal's
// nav links, used by BOTH the desktop Sidebar and the mobile hamburger
// menu so the two can never drift apart. Director-only items are filtered
// at render time via `filterNav`.

// Main nav — shown top-down. `hidden: true` suppresses an entry entirely
// (general-purpose toggle); `cap` gates the entry behind a capability flag
// from usePermissions, so per-user overrides in accessOverrides.js are
// respected (not just the raw Director role).
export const NAV = [
  { to: '/dashboard', label: 'Dashboard' },
  { to: '/plants', label: 'Plants' },
  { to: '/suppliers', label: 'Suppliers' },
  { to: '/parts', label: 'Parts' },
  { to: '/team', label: 'Proxemics Team' },
  // Reports — hidden for now (June 2026); flip `hidden` off to bring it back.
  { to: '/reports', label: 'Reports', hidden: true },
  // Billing Tracker — single entry covering Submit and Approvals tabs.
  { to: '/timesheets', label: 'Billing Tracker' },
  { to: '/billing', label: 'Billing Manager', cap: 'canSeeBillingManager' },
  // Invoices and Sales are desk-bound, Director-only back-office workflows
  // (composing invoices/PDFs, agreements, the sales library). `desktopOnly`
  // hides them from the nav on phone widths to declutter the mobile menu;
  // the routes still resolve if someone opens a direct link.
  { to: '/invoices', label: 'Invoices', cap: 'canSeeInvoices', desktopOnly: true },
  { to: '/sales', label: 'Sales', cap: 'canSeeSales', desktopOnly: true },
];

// "Pinned" nav — rendered at the bottom (always-accessible utility links).
export const PINNED_NAV = [
  { to: '/my-account', label: 'My Account' },
];

// Filter a nav list down to what the signed-in user may see. `perms` is the
// object returned by usePermissions(); an item with a `cap` only shows when
// that capability flag is true. `isMobile` drops `desktopOnly` items on phone
// widths (e.g. Invoices / Sales) so the mobile menu stays focused on the
// field-facing screens.
export function filterNav(items, perms = {}, isMobile = false) {
  return items.filter(
    (n) =>
      !n.hidden &&
      !(isMobile && n.desktopOnly) &&
      (!n.cap || perms[n.cap] === true),
  );
}
